<template>
  <div
    class="calendar-task-info"
    v-loading="loading"
    @click.stop=""
  >
    <div class="calendar-task-info-left">
      <span
        v-show="task.state === 0"
        class="ibass ibass-task-check"
        @click="changeTaskState(1)"
      />
      <span
        v-show="task.state === 1"
        class="ibass ibass-done"
        @click="changeTaskState(0)"
      />
    </div>
    <div class="calendar-task-info-main">
      <div class="calendar-task-info-title">
        {{ task.name }}
        <task-tags :tags="task.tags" />
      </div>
      <div class="calendar-task-info-matter-group">
        <span
          class="calendar-task-info-matter"
          :class="{
            'calendar-task-info-no-group': !task.taskGroupName
          }"
        >{{ task.matterName || '个人任务' }}</span>
        <span
          v-if="task.matterName && task.taskGroupName"
          class="calendar-task-info-group"
        >
        - {{ task.taskGroupName }}
        </span>
      </div>
      <div class="calendar-task-info-members">
        <span
          v-for="item in filteredAvatars"
          :key="item.avatar"
          class="calendar-task-info-member"
        >
          <img
            :src="item && item.avatar"
            class="calendar-task-info-avator"
          >
        </span>
        <span
          v-if="task.attendees && task.attendees.length > 5"
          class="calendar-task-info-number"
        >{{ task.attendees.length }}</span>
      </div>
      <div
        v-if="task.detail"
        class="calendar-task-info-desc"
      >{{ task.detail | filterContent }}</div>
      <div class="calendar-task-info-date">
        <span
          v-if="task.startTime"
          class="calendar-task-info-start"
        >{{ startTimeText }}</span>
        <span class="calendar-task-info-end">{{ endTimeText }}</span>
      </div>
      <div
        class="calendar-task-info-button"
        @click="showDetail"
      >
        <a class="calendar-task-info-button-detail">查看详情</a>
      </div>
    </div>
    <div
      v-show="timingAuth"
      class="calendar-task-info-right"
    >
      <span
        v-show="runningTaskId !== task.id"
        class="ibass ibass-trig-right"
        @click="startTiming"
      ></span>
      <span
        v-show="runningTaskId === task.id"
        class="ibass ibass-stop"
        @click="stopTiming"
      ></span>
    </div>
  </div>
</template>
<script>
import { TASK_DETAIL, PERMISSIONS } from '@/utils/constants'
import IlawService from '@/pages/index/service/ilaw'
import taskService from '@/pages/index/service/calendar'
import authorityService from '@/pages/index/service/authority'
import TaskTags from '@/biz-components/task-tags/index.vue'
export default {
  name: 'CalendarTaskInfo',
  props: {
    task: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  components: {
    TaskTags
  },
  filters: {
    filterContent (val) {
      if (navigator.userAgent.toLowerCase().indexOf('webkit') > -1) {
        return val
      }
      return val.length > 30 ? val.substring(0, 28) + '...' : val
    }
  },
  data () {
    return {
      format: this.task.dayType === TASK_DETAIL.DAY_TYPE_ALL ? 'YYYY年M月DD日' : 'YYYY年M月DD日 H:mm',
      timingAuth: false,
      matterAuths: [],
      loading: false
    }
  },
  computed: {
    startTimeText () {
      return `${moment(this.task.startTime).format(this.format)} 开始`
    },
    endTimeText () {
      return `${moment(this.task.endTime || this.task.dueTime).format(this.format)} ${this.task.dueTime ? '到期' : '结束'}`
    },
    filteredAvatars () {
      return this.task.attendees ? this.task.attendees.slice(0, 5) : []
    },
    runningTaskId () {
      return this.$store.state.time.timing.taskPkId
    }
  },
  watch: {
    matterAuths (newVal) {
      let userid = this.$store.state.user.user.id
      this.timingAuth = this.matterAuths.includes(PERMISSIONS.MAT_MATTER_TIMELOG_ADD) ||
        (this.task.attendees && this.task.attendees.some(attendee => attendee && attendee.id === userid)) ||
        this.task.createUserId === userid
    }
  },
  created () {
    let matterId = this.$route.params.matterId
    if (matterId) {
      let userid = this.$store.state.user.user.id
      authorityService.get(userid, authorityService.MATTER, matterId).then(res => {
        this.matterAuths = res || []
      })
    } else {
      this.matterAuths = []
    }
  },
  methods: {
    startTiming () {
      if (this.loading) {
        return false
      }
      const obj = {
        taskPkId: this.task.id,
        name: this.task.name,
        workTypeId: this.task.workTypeId,
        matterPkId: this.task.matterId,
        matterName: this.task.matterName
      }
      this.loading = true
      // 云信通知可能存在延迟，为了避免这种情况，调用getTiming进行查询
      IlawService.startTiming(obj).then(() => {
        this.$store.dispatch('SYNC.TIMING_INITIAL')
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    stopTiming () {
      // 调用停止计时，云信通知将会处理状态的变化
      let pkId = this.$store.state.time.timing.pkId
      if (pkId) {
        IlawService.stopTiming(pkId).then(() => {
          this.$store.dispatch('SYNC.TIMING_INITIAL')
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      }
    },
    // 改变任务状态
    changeTaskState (state) {
      if (this.loading) {
        return
      }
      this.loading = true
      taskService.changeTaskState(this.task.id, state).then(res => {
        // 如果成功，更新任务状态
        this.task.state = state
        // 如果ID一致，那么同时会尝试停止计时
        if (this.$store.state.time.timing.taskPkId === this.task.id) {
          this.stopTiming()
        }
        this.$emit('finishTask')
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    showDetail () {
      this.$postMessage.openTaskDetail(this.task.id)
      this.$emit('close')
    }
  }
}
</script>
<style lang="stylus">
.calendar-task-info
  display flex
  justify-content flex-start
  align-items flex-start
  flex-wrap nowrap
  width 260px
  padding 5px 0
  &-start,
  &-end
    display block
  &-left
    height 18px
    // margin-top 2px
    font-size 18px
    .ibass-task-check
      color #999
      transition all .2s
      cursor pointer
    .ibass-done
      color #fa8919
      transition all .2s
      cursor pointer
    &:hover
      .ibass-task-check,
      .ibass-done
        color #FDBA78
        transform scale(1.1)
  &-main
    flex 1
    padding 0 5px 0 10px
  &-right
    height 16px
    color #fa8919
    margin-top 2px
    cursor pointer
    font-size 1rem
  &-title
    color #4a4a4a
    display -webkit-box
    -webkit-line-clamp 2
    -webkit-box-orient vertical
    overflow hidden
    text-overflow ellipsis
    word-break break-all
    overflow hidden
  &-matter
    display inline-block
    max-width 100px
    overflow hidden
    white-space nowrap
    text-overflow ellipsis
    &.calendar-task-info-no-group
      max-width 220px
    &-group
      margin-top 10px
      font-size .75rem
      color #8590a6
  &-group
    display inline-block
    margin-left .3em
    max-width 100px
    overflow hidden
    white-space nowrap
    text-overflow ellipsis
  &-members
    display flex
    margin-top 10px
  &-avator,
  &-number,
  &-add
    width 24px
    height 24px
    border-radius 50%
    margin-right 5px
  &-number
    line-height 24px
    background-color #FA8919
    text-align center
    color #fff
  &-desc
    margin-top 15px
    display -webkit-box
    -webkit-line-clamp 2
    -webkit-box-orient vertical
    color #666
    overflow hidden
  &-date
    margin-top 8px
    color #666
  &-button
    margin-top 15px
    &-detail
      background-color #f8f8f9
      padding 7px 0
      display flex
      justify-content center
      align-items center
      border-radius 20px
      font-size .75rem
      &:hover
        box-shadow 0 1px 3px rgba(0, 0, 0, .3)
</style>
